<template>
  <div class="portlet-body form">
    <hr>
    <div v-show="loading !== 0" class="row">
      <div class="col-sm-12">
        <span>
          <div class="progress">
            <div
                :aria-valuemax="progress"
                :aria-valuenow="loading"
                :style="{ width: currentProgress + '%' }"
                aria-valuemin="0"
                class="progress-bar"
                role="progressbar"
            >
              <span class="sr-only">{{ currentProgress }}% Complete</span>
            </div>
          </div>
          <h2>{{ trans('form.please_wait') }}...</h2>
          <ring-loader></ring-loader>
        </span>
      </div>
    </div>
    <template v-for="(mealData, mealDate, index) in sortedMeals">
      <div v-show="loading === 0" :key="index">
        <div class="row show-block-button">
          <div class="col-md-6" style="padding-left: 0">
            <h3>{{ mealDate }} {{ getDayNameFromDate(mealDate) }}</h3>
          </div>
          <div class="col-md-6" style="padding-right: 0">
            <div v-if="isGranted" class="btn-set pull-right">
              <button class="btn green" @click="editMenu(mealDate)">
                {{ trans('menu_planner_select.edit') }}
              </button>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-sm-12">
            <table id="meal-menu-planner-table-show" class="table table-bordered">
              <tbody>
              <tr>
                <td class="menu-header"><b>{{ trans('menu_planner.final_meal') }}</b></td>
                <td class="menu-header"><b>{{ trans('meal.entity.rate') }}</b></td>
                <td class="menu-header"><b>{{ trans('badge.badge') }}</b></td>
                <td class="menu-header"><b>{{ trans('meal.entity.tags') }}</b></td>
                <td class="menu-header"><b>{{ trans('meal.entity.sizes') }}</b></td>
                <td class="menu-header"><b>{{ trans('meal.entity.costs') }}</b></td>
                <td class="menu-header"><b>{{ trans('meal.entity.prices') }}</b></td>
              </tr>
              <template v-for="(selectType, position) in mealData">
                <tr :key="position">
                  <td class="menu-header-select-type" colspan="6">
                    {{ selectType.selectType.value }}
                  </td>
                </tr>
                <tr v-for="(exMeal, exMealIndex) in selectType.meals" :key="`${date}-${position}-${exMealIndex}`">
                  <td v-text="exMeal.meal.name"></td>
                  <td v-text="Math.round(exMeal.meal.rate * 100) / 100"></td>
                  <td>
                    <template v-for="mealBadge in exMeal.meal.mealBadges">
                      <div v-if="mealBadge.validFrom <= date && mealBadge.validTo >= date" :key="mealBadge.id">
                        <a @click.prevent="showMealBadge(mealBadge.badge.id)">
                          <i class="fa fa-link"></i>&nbsp;{{ mealBadge.badge.name }}
                        </a>
                      </div>
                    </template>
                  </td>
                  <td>
                  <span
                      v-if="mealTags[exMeal.meal.id] === false"
                      class="glyphicon glyphicon-refresh glyphicon-refresh-animate">
                  </span>
                    <span v-for="(tag, tagIndex) in mealTags[exMeal.meal.id] || []" v-else :key="tagIndex">
                    {{ tag.value }} <br>
                  </span>
                  </td>
                  <td>
                    <template v-for="(serving, servingIndex) in exMeal.meal.servings">
                      <span :key="`span-${servingIndex}`" v-text="serving.size"></span>
                      <br :key="`br-${servingIndex}`"/>
                    </template>
                  </td>
                  <td>
                    <template v-for="(serving, servingIndex) in exMeal.meal.servings">
                      <span :key="`span-${servingIndex}`" v-text="dcNumberFormat(serving.productionCost)"></span>
                      <br :key="`br-${servingIndex}`"/>
                    </template>
                  </td>
                  <td>
                    <template v-for="(serving, servingIndex) in exMeal.meal.servings">
                    <span
                        :key="`span-${servingIndex}`"
                        :style="serving.suggestedLowestPrice === null ? 'color: red' : ''"
                        v-text="serving.suggestedLowestPrice === null ?
                          'Brak ceny' :
                          dcNumberFormat(serving.suggestedLowestPrice)"
                    ></span>
                      <br :key="`br-${servingIndex}`"/>
                    </template>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

export default {
  components: {
    RingLoader,
  },
  props: {
    date: {
      type: [String, Date],
      default: '',
    },
    brand: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      loading: 0,
      progress: 0,
      expressMeals: [],
      mealTags: {},
    }
  },
  computed: {
    currentProgress() {
      if (this.progress === 0) {
        return 0
      }

      return (1 - this.loading / this.progress) * 100
    },
    isGranted() {
      return Object.values(window.appValues.menuPlannerSelect.permissions).includes('MENU_PLANNER_SELECT_UPDATE')
    },
    sortedMeals() {
      const result = {}

      for (const date in this.expressMeals) {
        if (!result[date]) {
          result[date] = {}
        }

        this.expressMeals[date].forEach(meal => {
          meal.selectTypes.forEach(selectType => {
            if (!result[date][selectType.position]) {
              result[date][selectType.position] = {
                selectType,
                meals: []
              }
            }

            result[date][selectType.position].meals.push(meal)
          })
        })
      }

      return result
    }
  },
  watch: {
    date() {
      this.load()
    },
    brand() {
      this.load()
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.expressMeals = []
      this.getExpress()
    },
    editMenu(date) {
      this.$router.push({
        name: 'menu-planner-select-edit',
        params: {
          date: date,
          brand: this.brand,
          showDate: this.date,
        }
      })
    },
    getExpress() {
      this.loading++
      this.progress++

      const url = Routing.generate('api_show_meal_menu_planner', {
        brand: this.brand,
        date: this.date,
      })

      this.$http.get(url).then(response => {
        this.expressMeals = response.data
        this.getTagsForMeals()
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    trans(id) {
      return Translator.trans(id)
    },
    getDayNameFromDate(date) {
      return (new moment(date)).locale('pl').format('dddd')
    },
    getTagsForMeals() {
      const mealIds = Object.keys(this.mealTags)

      Object.values(this.expressMeals).forEach(expressMeals => {
        expressMeals.forEach(expressMeal => {
          const mealId = expressMeal.meal.id.toString()
          if (!mealIds.includes(mealId)) {
            mealIds.push(mealId)
            this.$set(this.mealTags, mealId, false)
          }
        })
      })

      mealIds.forEach(mealId => {
        const url = Routing.generate('api_get_menu_planner_meal_tags', { meal: mealId })
        this.$http.get(url).then(response => {
          this.$set(this.mealTags, mealId, response.data)
        })
      })
    },
    showMealBadge(badgeId) {
      window.open(Routing.generate('badge_show', { id: badgeId }), '_blank')
    },
  },
}
</script>

<style scoped>
.menu-header {
  background: #3B3F51;
  color: #fff;
  width: 150px;
}

.menu-header-select-type {
  background: #919199;
  color: #fff;
  font-weight: bold;
}

.show-block-button {
  margin: 20px 0 0 0;
}

.show-block-button h3 {
  margin: 0;
}

.progress {
  margin: 20px 0;
}
</style>
